import GUI from 'lil-gui'

export class FPSController
{
    constructor()
    {
        this.gui = new GUI()
        this.gui.close();
        this.fpsData = {
            lastElapsedTime: 0,
            ticks: 0,
            totalDelta: 0,
            fps: 0
        }
        this.fpsUIController = this.gui.add(this.fpsData, 'fps')
    }

    tick(elapsedTime)
    {
        const delta = elapsedTime - this.fpsData.lastElapsedTime;

        this.fpsData.ticks++;

        this.fpsData.totalDelta += delta;

        if(this.fpsData.totalDelta>1)
        {

            this.fpsData.fps = this.fpsData.ticks/this.fpsData.totalDelta
            this.fpsData.totalDelta = 0;
            this.fpsData.ticks = 0;
            this.fpsUIController.updateDisplay()
        }

        this.fpsData.lastElapsedTime = elapsedTime;
    }
}